import React from 'react';

import { Section } from '@gogame/components';

import { useExtraContext } from '../ExtraContext';
import { AdvertisingPopulations } from './AdvertisingPopulations';

export const AdvertisingPopulationSection = () => {
  const { hasCreativesDimension } = useExtraContext();
  return (
    <Section
      title={hasCreativesDimension ? 'Advertising Population' : 'Population'}
    >
      <AdvertisingPopulations />
    </Section>
  );
};
